import i18n from 'i18next';
import {  initReactI18next } from 'react-i18next';
import common_en from '../locale/en/common.json';
import common_de from '../locale/de/common.json';
import common_da from '../locale/da/common.json';

i18n
	.use(initReactI18next)
	.init({
		wait: true,
		resources: {
			en: {
				common: common_en 
			},
			de: {
				common: common_de 
			},
			da: {
				common: common_da
			},
		},
		lng: 'en',
		nsSeparator: false,
		keySeparator: false,
		defaultNS: 'common',
		returnEmptyString: false,
		// do not load a fallback
		fallbackLng: false,

		interpolation: {
			escapeValue: false
		}
	});

export const t = i18n.t.bind(i18n);
export const setLanguage = i18n.changeLanguage.bind(i18n);
